// Maps calculator IDs ↔ URL slugs for path-based routing.
// Slugs are SEO-friendly: descriptive, keyword-rich, kebab-case.

export const SLUG_BY_ID = {
  // Featured
  'unit-converter': 'unit-converter',
  'currency': 'currency-converter',
  'scientific': 'scientific-calculator',

  // Mathematics
  'eq-solver': 'equation-solver',
  'matrix': 'matrix-calculator',
  'complex': 'complex-number-calculator',
  'base': 'base-number-converter',
  'prime': 'prime-factorisation',

  // Calculus
  'derivative': 'derivative-calculator',
  'integral': 'integral-calculator',
  'limit': 'limit-calculator',
  'series': 'series-calculator',
  'grapher': 'function-grapher',

  // Physics
  'kinematics': 'kinematics-calculator',
  'newtons-laws': 'newtons-laws-calculator',
  'energy': 'energy-power-calculator',
  'circuits': 'electric-circuit-calculator',
  'electromagnetism': 'electromagnetism-calculator',
  'optics': 'optics-calculator',
  'thermodynamics': 'thermodynamics-calculator',
  'waves': 'waves-sound-calculator',
  'relativity': 'relativity-calculator',

  // Chemistry
  'molar-mass': 'molar-mass-calculator',
  'stoichiometry': 'stoichiometry-calculator',
  'ph': 'ph-calculator',
  'gas-laws': 'gas-laws-calculator',
  'electrochemistry': 'electrochemistry-calculator',
  'nuclear': 'nuclear-decay-calculator',

  // Statistics
  'descriptive': 'descriptive-statistics',
  'probability': 'probability-calculator',
  'hypothesis': 'hypothesis-testing',
  'regression': 'regression-calculator',
  'distribution': 'distribution-tables',

  // Biology / Earth
  'genetics': 'genetics-calculator',
  'population': 'population-growth-calculator',
  'astronomy': 'astronomy-calculator',
  'geoscience': 'geoscience-calculator',

  // Engineering (legacy)
  'hydraulics': 'hydraulics-calculator',
  'sig-figs': 'significant-figures-calculator',
  'vector': 'vector-calculator',
  'body-metrics': 'body-metrics-calculator',

  // Finance
  'emi': 'emi-calculator',
  'mortgage': 'mortgage-calculator',
  'compound-interest': 'compound-interest-calculator',
  'sip': 'sip-calculator',
  'gst': 'gst-calculator',
  'salary': 'salary-calculator',
  'discount': 'discount-calculator',
  'profit-loss': 'profit-loss-calculator',
  'roi': 'roi-calculator',
  'tip': 'tip-calculator',
  'ppf': 'ppf-calculator',
  'inflation': 'inflation-calculator',

  // Construction
  'concrete': 'concrete-calculator',
  'paint': 'paint-calculator',
  'tile': 'tile-calculator',
  'brick': 'brick-mortar-calculator',
  'roof': 'roof-calculator',
  'flooring': 'flooring-calculator',
  'rebar': 'rebar-calculator',
  'staircase': 'staircase-calculator',
  'sand-aggregate': 'sand-aggregate-calculator',
  'room-area': 'room-area-calculator',

  // Health & Fitness
  'calorie': 'calorie-tdee-calculator',
  'macro': 'macro-calculator',
  'one-rep-max': 'one-rep-max-calculator',
  'running-pace': 'running-pace-calculator',
  'water-intake': 'water-intake-calculator',
  'body-fat': 'body-fat-calculator',
  'pregnancy': 'pregnancy-due-date-calculator',
  'vo2max': 'vo2-max-calculator',
  'heart-rate': 'heart-rate-zones',
  'sleep-cycle': 'sleep-cycle-calculator',

  // Engineering Standards (data tables)
  'oring': 'o-ring-sizes',
  'bolt': 'bolt-nut-sizes',
  'pipe': 'pipe-sizes',
  'wire-gauge': 'wire-gauge-awg',
  'sheet-metal': 'sheet-metal-gauge',
  'bearing': 'bearing-sizes',
  'drill-bit': 'drill-bit-sizes',

  // Medical Reference
  'needle': 'needle-syringe-gauge',
  'iv-cannula': 'iv-cannula-sizes',
  'catheter': 'catheter-french-sizes',
  'suture': 'suture-sizes',
  'et-tube': 'et-tube-sizes',
  'bp-reference': 'blood-pressure-reference',
  'drug-dosage': 'drug-dosage-calculator',
  'medical-converter': 'medical-unit-converter',

  // Text & Numbers
  'text-case': 'text-case-converter',
  'text-analysis': 'word-character-count',
  'number-to-words': 'number-to-words',
  'hash-generator': 'hash-generator',
};

// Reverse map: slug → calculator id
export const ID_BY_SLUG = Object.fromEntries(
  Object.entries(SLUG_BY_ID).map(([id, slug]) => [slug, id])
);

// Map category id → slug
export const CATEGORY_SLUGS = {
  'featured': 'featured',
  'finance': 'finance-calculators',
  'construction': 'construction-calculators',
  'health-fitness': 'health-fitness-calculators',
  'engineering': 'engineering-standards',
  'medical': 'medical-reference',
  'text-numbers': 'text-numbers-tools',
  'mathematics': 'mathematics-calculators',
  'calculus': 'calculus-calculators',
  'physics': 'physics-calculators',
  'chemistry': 'chemistry-calculators',
  'statistics': 'statistics-calculators',
  'biology': 'biology-earth-calculators',
};

export const CATEGORY_ID_BY_SLUG = Object.fromEntries(
  Object.entries(CATEGORY_SLUGS).map(([id, slug]) => [slug, id])
);

export const slugFor = (id) => SLUG_BY_ID[id] || id;
export const idFromSlug = (slug) => ID_BY_SLUG[slug];
export const categorySlugFor = (id) => CATEGORY_SLUGS[id] || id;
export const categoryIdFromSlug = (slug) => CATEGORY_ID_BY_SLUG[slug];
